module.exports = { "default": require("core-js/library/fn/number/is-nan"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/core-js/number/is-nan.js
// module id = ejtE
// module chunks = 0